import { render, staticRenderFns } from "./InstitutionObjectives.vue?vue&type=template&id=1ab0e1f0"
import script from "./InstitutionObjectives.vue?vue&type=script&lang=js"
export * from "./InstitutionObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports